import { useQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import { personApi } from '../../services/personApi';

export const personKeys = {
  all: ['persons'] as const,
  lists: () => [...personKeys.all, 'list'] as const,
  list: (filters?: { pageNumber?: number; pageSize?: number; search?: string }) =>
    [...personKeys.lists(), filters] as const,
  details: () => [...personKeys.all, 'detail'] as const,
  detail: (id: string) => [...personKeys.details(), id] as const,
};

export function useGetPerson(id: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: personKeys.detail(id),
    queryFn: async () => {
      const response = await personApi.getById(id);
      if (!response.isSuccess) {
        toast.error(`Error: ${response.errorMessage || 'Failed to fetch person'}`);
      }
      return response;
    },
    enabled: options?.enabled ?? !!id,
  });
}

export function useGetPersons() {
  return useQuery({
    queryKey: personKeys.lists(),
    queryFn: async () => {
      const response = await personApi.getList();
      if (!response.isSuccess) {
        toast.error(`Error: ${response.errorMessage || 'Failed to fetch persons'}`);
      }
      return response;
    },
  });
}

export function useGetPersonsPaged(
  pageNumber: number = 1,
  pageSize: number = 10,
  search?: string
) {
  return useQuery({
    queryKey: personKeys.list({ pageNumber, pageSize, search }),
    queryFn: async () => {
      const response = await personApi.getPagedList(pageNumber, pageSize, search);
      if (!response.isSuccess) {
        toast.error(`Error: ${response.errorMessage || 'Failed to fetch persons'}`);
      }
      return response;
    },
  });
}
